import MessagePanel from "./framework/component/container/MessagePanel";
import React, {useContext} from "react";
import {useNavigate} from "react-router-dom";
import AppContext from "./framework/AppContext";
import {MessagePanelType} from "./framework/component/container/MessagePanelType";
import {ResearcherStatus} from "./researcher/model/ResearcherStatus";

/**
 * This component represents the home page for an unregistered researcher
 */
export default function UnregisteredResearcherHome() {
  const navigate = useNavigate();
  const appContext = useContext(AppContext);
  const hasSignedUpViaInvitation = appContext?.userProfile.hasSignedUpViaInvitation;

  return <>
    <MessagePanel title={"Welcome to the UK Biobank AMS"}>
      <p>This portal will allow you to create and manage your applications to use UK Biobank data in
        your researcher
        projects.</p>
      {(appContext?.userProfile.researcherStatus === ResearcherStatus.SIGNED_UP
          || appContext?.userProfile.researcherStatus === ResearcherStatus.DRAFT_REG) && (
          hasSignedUpViaInvitation ?
              (<p>You must complete a registration before you are granted access to other
                functionalities within the
                system.</p>) :
              (<p>You must complete an application and register before you are granted access to
                other
                functionalities
                within the system.</p>)

      )}
    </MessagePanel>
    {(appContext?.userProfile.researcherStatus === ResearcherStatus.REG_SUBMIT
            || appContext?.userProfile.researcherStatus === ResearcherStatus.REG_REVIEW) &&
        <MessagePanel
            title={`${!appContext.userProfile.hasSignedUpViaInvitation ? 'Application & r' : 'R'}egistration request pending`}
            panelType={MessagePanelType.WARNING}>
          {hasSignedUpViaInvitation ?
              (<p>Your registration is under review.</p>) :
              (<p>Your application and registration is under review.</p>)
          }
          <p>We will be in touch with an update on the status of your request.</p>
        </MessagePanel>
    }
    {(appContext?.userProfile.researcherStatus === ResearcherStatus.SIGNED_UP
            || appContext?.userProfile.researcherStatus === ResearcherStatus.DRAFT_REG)
        &&
        <div id={"homeBtnArea"} className={"btnArea"}>
          <button id="homeApplicationTypeBtn" type="button" className="btn btn-primary"
                  data-testid="app-type"
                  onClick={() => {
                    navigate(!hasSignedUpViaInvitation ? "application-type" : "/register")
                  }}>
            {!hasSignedUpViaInvitation ? "Start your Application" : "Start Registration"}
          </button>
        </div>}
  </>;
}